export { default } from './Paper';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Paper/index.js
// module id = 74
// module chunks = 2